// eslint-disable-next-line import/no-anonymous-default-export
export default {
  development: {
    API_URL: "https://api-v2.help-clic.fr",
    // API_URL: "https://c79e-102-156-203-27.ngrok-free.app",

    // API_URL: "http://192.168.1.14:3000",

    // API_URL: "http://192.168.1.10:3002",

    BaseURL: "http://localhost:3000",
    APPLICATION_NAME: "help-clic",
  },
  production: {
    API_URL: "https://api-v2.help-clic.fr",
    BaseURL: "https://app.help-clic.fr",
    APPLICATION_NAME: "help-clic",
  },
};
